import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

export const useInt = () => {
  const { internationalization, lang } = useContext(ContentContext);

  const t = (key: string): string => {
    if (!internationalization || !key) {
      return key;
    }

    const translation = internationalization[key];

    if (!translation) {
      return key;
    }

    if (typeof translation === 'string') {
      return translation;
    }

    if (typeof translation === 'object') {
      const currentLang = lang || 'en';
      const fallbackLang = 'en';

      if (translation[currentLang]) {
        return translation[currentLang];
      }

      if (translation[fallbackLang]) {
        return translation[fallbackLang];
      }
    }

    return key;
  };

  return { t };
};
